export default "__VITE_ASSET__CvL_km$l__"